module.exports = __webpack_public_path__ + "static/media/dott-logo.c63e9978.png";